import BenMillner from "./ben_millner.webp"
import BenMiddlicott from "./ben_middlicott.webp"
import CalleHelbo from "./calle_helbo.webp"
import CallumAdams from "./callum_adams.webp"
import ChrisGent from "./chris_gent.webp"
import EdHemsworth from "./ed_hemsworth.webp"
import JackWood from "./jack_wood.webp"
import JamesHarvey from "./james_harvey.webp"
import JonCaller from "./jon_caller.webp"
import LukeHeath from "./luke_heath.webp"
import MarioLabestos from "./mario_labestos.webp"
import MichaelaghTennyson from "./michaelagh_tennyson.webp"
import OleSchack from "./ole_schack.webp"
import OllieHarcombe from "./oliver_harcombe.webp"
import OscarHemsworth from "./oscar_hemsworth.webp"
import OliverMcguireHodge from "./oliver_mcguire-hodge.webp"
import RickyCastell from "./ricky_castell.webp"
import SebFrancois from "./seb_francois.webp"
import TaylorSmith from "./taylor_smith.webp"

export const pictures = {
	BenMillner,
	BenMiddlicott,
	CalleHelbo,
	CallumAdams,
	ChrisGent,
	EdHemsworth,
	JackWood,
	JamesHarvey,
	JonCaller,
	LukeHeath,
	MarioLabestos,
	MichaelaghTennyson,
	OleSchack,
	OllieHarcombe,
	OscarHemsworth,
	OliverMcguireHodge,
	RickyCastell,
	SebFrancois,
	TaylorSmith,
}
